export default {
  title: {
    ar: 'هذا غير صحيح.',
    en: 'That’s not correct.'
  },

  description: {
    ar: '!لكنك قريب جدًا! ليس هذا هو الجواب الصحيح هذه المرة،لكنك قادر على ذلك. استمر',
    en: 'Close one! Not the right answer this time, but you’ve got this. Keep going!'
  },

  next: {
    ar: 'السؤال التالي',
    en: 'Next question'
  },

  complete: {
    ar: 'شاهد نتيجتك',
    en: 'Complete the Quiz'
  }
};
